export default {"src":"/_next/static/media/call-yellow.92ac2cd3.svg","height":25,"width":25,"blurWidth":0,"blurHeight":0};